<div class="container">
    <div class="common loginformsection">				
        <div class="loginform">
            <div class="logodiv text-center">
                <a routerLink="/dashboard" href="javascript:void(0)"><img src="assets/images/logo.png"/></a>
            </div>
            <form class="mt-5">
                <div class="form-group">
                    <h4 class="signhedng">Password reset link sent</h4>
                    <p class="fgtpwd_txt restpwdtxtmgbtm">Check your email and click the link to continue resetting your password.</p>
                </div>
            </form>
            
        </div>
    </div>
</div>